import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationAssetDto extends EpimsBaseEntityDto {

 ObligationFacilityId: string;
 Remarks: string;
 CountryId: string;
 StateId: string;
 LgaId: string;
 AssetId: string;
 LandName: string;
 CreatedStaff: string;
 DateCreated: Date;
 SubscriptionUserId: string;
 NewLandId: string;
}
